import React from 'react';

function PromptCachingContent() {
  return (
    <>
      <p>Details about how Repo Prompt handles prompt caching for efficiency.</p>
      <h3>Caching Implementation</h3>
      <p>Yes, when using Anthropic directly, prompt caching is employed. However, due to the complexity of file editing workflows, chat history is generated to ensure only the latest files are sent with each message, and as a result, this can interfere with some prompt caching techniques.</p>
    </>
  );
}

export default PromptCachingContent;